import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { PipeModule } from "../../../../../../pipes/pipes.module";
import { CustomerSelectorPopoverItemComponent } from "./customer-selector-popover-item.component";

@NgModule({
	declarations: [CustomerSelectorPopoverItemComponent],
	imports: [CommonModule, IonicModule, PipeModule],
	exports: [CustomerSelectorPopoverItemComponent]
})
export class CustomerSelectorPopoverItemModule {}
